/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');

  /**
   * Replaces "Chatwoot" in text with the installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;
    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/Chatwoot/g, installationName);
  };

  /**
   * Replaces "Daxx" in text with the brand name
   */
  const replaceBrandName = text => {
    if (!text) return text;
    const brandName = globalConfig.value?.brandName;
    if (!brandName) return text;

    return text.replace(/Daxx/g, brandName);
  };

  /**
   * Aplica ambas as substituições (Installation e Brand) no mesmo texto
   * @param {string} text - O texto original
   * @returns {string} - O texto formatado com ambas as marcas
   */
  const applyBranding = text => {
    if (!text) return text;

    // Encadeia as substituições
    let processedText = replaceInstallationName(text);
    processedText = replaceBrandName(processedText);

    return processedText;
  };

  return {
    replaceInstallationName,
    replaceBrandName,
    applyBranding, // Nova função exportada
  };
}
